'use client';

import HeroSection from './HeroSection';
import StorySection from './StorySection';
import ValuesSection from './ValuesSection';
import CTASection from './CTASection';
import Footer from '@/app/guest-stories/components/Footer';

export default function AboutUsInteractive() {
  return (
    <>
      <HeroSection />
      <StorySection />
      <ValuesSection />
      <CTASection />
      <Footer />
    </>
  );
}